module.exports = __webpack_public_path__ + "static/MT_Benefit-02.9df1f717.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-02.png
// module id = 1462
// module chunks = 169858455373905